export default __webpack_public_path__ + "static/media/bulb-pink.50c1ce4a.svg";